module.exports = __webpack_public_path__ + "img/Referenzen_Security14.2bb96b4a.jpg";